import { useCallback } from "react"
import { useRecoilState } from "recoil"

import CustomOverlayModal from "../common/CustomOverlayModal"
import { sessionEndModalAtom } from "../../recoil/atoms/sessionModalData"

const SessionEndModal = () => {
  const [sessionEndModal, setSessionEndModal] =
    useRecoilState(sessionEndModalAtom)

  const onCancel = useCallback(() => {
    setSessionEndModal(null) // close the modal
    
    if(sessionEndModal?.sessionEndModalCloseButtonLink)
      window.open(sessionEndModal?.sessionEndModalCloseButtonLink, "_self")
    else
      window.close()

  }, [setSessionEndModal, sessionEndModal?.sessionEndModalCloseButtonLink])

  if (!sessionEndModal) return null

  const {
    sessionEndModalTitle,
    sessionEndModalMessage,
    sessionEndModalCloseButtonText
  } = sessionEndModal

  return (
    <CustomOverlayModal
      title={sessionEndModalTitle}
      subtitle={sessionEndModalMessage}
      showActionButton={true}
      closeButtonText={sessionEndModalCloseButtonText}
      onCancel={onCancel}
    />
  )
}

export default SessionEndModal
